import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

interface WifiSuccessMessageProps {
  title: string;
  description: string;
  onClose: () => void;
}

const WifiSuccessMessage: React.FC<WifiSuccessMessageProps> = ({
  title,
  description,
  onClose,
}) => {
  return (
    <div className="bg-[#f2fcf5] border-[2px] border-[#16a34a] rounded-[20px] p-4 shadow-md max-w-[450px] w-full mx-auto min-w-[350px]">
      <div className="flex items-start">
        <div className="flex-shrink-0 mr-2">
          <CheckCircleIcon className="h-6 w-6 text-[#16a34a]" />
        </div>
        <div className="flex-1 text-left flex flex-col gap-1">
          <div className="text-[#0f4d6d] font-bold text-[16px] leading-snug">
            {title}
          </div>
          <div className="text-[#0f4d6d] text-[16px] leading-snug">
            {description}
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-2">
        <button
          onClick={onClose}
          className="text-[#0ea5e9] font-medium text-[16px] hover:text-[#0284c7] transition-colors cursor-pointer focus:outline-none"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default WifiSuccessMessage;
